<template>
  <v-container
    fluid
    grid-list-xl
  >
    <app-mapeamento
      :fim="mapeamento.fimPerComportComissao"
      :inicio="mapeamento.inicioPerComportComissao"
      acesso="COMISSAO"
      titulo="Normalização Comportamental"
    >
      <template v-slot:body>
        <v-row
          v-if="prazoAtual || prazoEsgotado"
          no-gutters
        >
          <v-col>
            <v-row dense>
              <v-toolbar flat>
                <v-toolbar-title>
                  <h2
                    class="title primary--text text--darken-1 text-no-wrap mt-0"
                  >
                    FILTROS
                  </h2>
                </v-toolbar-title>
              </v-toolbar>
            </v-row>
            <v-row no-gutters>
              <v-col
                v-show="!mapeamento.mapeamentoImportado"
                cols="12"
              >
                <v-autocomplete
                  v-model="filtros.unidades"
                  :item-text="getUnidadeSiglaAndNome"
                  :items="unidades"
                  :search-input.sync="pesquisaUnidades"
                  label="Unidade(s):"
                  placeholder="Digite para pesquisar..."
                  multiple
                  prepend-icon="account_balance"
                  return-object
                  @change="pesquisaUnidades = ''"
                >
                  <template
                    v-if="unidades.length > 0"
                    v-slot:prepend-item
                  >
                    <v-list-item @click="toggleItens">
                      <v-list-item-action>
                        <v-icon
                          :color="filtros.unidades.length > 0 ? 'primary' : ''"
                        >
                          {{ icon }}
                        </v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>Selecionar todas</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2" />
                  </template>
                  <template v-slot:selection="data">
                    <v-chip
                      :input-value="data.selected"
                      class="chip--select-multi"
                      close
                      color="primary"
                      small
                      text-color="white"
                      @click:close="removeUnidade(data.item)"
                    >
                      {{ data.item.sigla }}
                    </v-chip>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col
                cols="12"
                sm="6"
              >
                <v-row no-gutters>
                  <v-autocomplete
                    v-model="filtros.situacao"
                    :items="situacoes"
                    item-text="descricao"
                    item-value="id"
                    label="Situação:"
                    placeholder="Digite para pesquisar..."
                    prepend-icon="filter_list"
                  />
                </v-row>
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-row no-gutters>
                  <v-autocomplete
                    v-model="filtros.competencia"
                    :auto-select-first="true"
                    :disabled="filtros.situacao === 'NAO_ASSOCIADOS'"
                    :items="competenciasFiltro"
                    item-text="nome"
                    label="Competência:"
                    placeholder="Digite para pesquisar..."
                    prepend-icon="format_list_bulleted"
                    return-object
                  >
                    <template v-slot:item="data">
                      <v-tooltip
                        max-width="500px"
                        top
                      >
                        <template v-slot:activator="{ on }">
                          <span v-on="on">{{ data.item.nome }}</span>
                        </template>
                        <span v-if="data.item.nome === 'Todas'">Todas</span>
                        <span v-else>{{ data.item.descricao }}</span>
                      </v-tooltip>
                    </template>
                  </v-autocomplete>
                </v-row>
              </v-col>
            </v-row>

            <v-row>
              <v-toolbar flat>
                <v-toolbar-title>
                  <h2
                    class="title primary--text text--darken-1 text-no-wrap mt-0"
                  >
                    COMPORTAMENTOS ({{ comportamentos.length }})
                  </h2>
                </v-toolbar-title>
              </v-toolbar>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="4"
                sm="6"
              >
                <app-sort v-model="opcoes" />
              </v-col>
              <v-col
                cols="12"
                md="4"
                sm="6"
              >
                <app-search v-model="opcoes" />
              </v-col>
              <!-- Formulário associação de competência -->
              <v-col
                cols="12"
                md="4"
                sm="6"
              >
                <v-row no-gutters>
                  <v-autocomplete
                    v-if="prazoAtual"
                    v-model="competencia"
                    :auto-select-first="true"
                    :disabled="selectedComportamentos.length === 0"
                    :items="competenciasAssociacao"
                    dense
                    item-text="nome"
                    item-value="id"
                    label="Associar competência:"
                    placeholder="Digite para pesquisar..."
                    outlined
                    prepend-icon="format_list_bulleted"
                    return-object
                    @change="associar"
                  >
                    <template v-slot:item="data">
                      <v-tooltip
                        max-width="500px"
                        top
                      >
                        <template v-slot:activator="{ on }">
                          <span v-on="on">{{ data.item.nome }}</span>
                        </template>
                        <span
                          v-if="data.item.nome === 'Nenhuma...'"
                        >Nenhuma competência comportamental</span>
                        <span v-else>{{ data.item.descricao }}</span>
                      </v-tooltip>
                    </template>
                  </v-autocomplete>
                </v-row>
              </v-col>
            </v-row>

            <!-- Tabela de comportamentos -->
            <v-row
              v-if="prazoAtual || prazoEsgotado"
              no-gutters
            >
              <v-col>
                <v-data-table
                  v-model="selectedComportamentos"
                  :headers="headers"
                  :items="comportamentos"
                  :search="opcoes.pesquisa"
                  :sort-by="opcoes.ordenarPor"
                  :sort-desc="opcoes.decrescente"
                  :custom-filter="customFilter"
                  :show-select="prazoAtual"
                  class="elevation-0"
                >
                  <template v-slot:[`header.data-table-select`]="{ on, props }">
                    <v-simple-checkbox
                      :disabled="
                        comportamentos.length === 0 ||
                          filtros.situacao === 'ORIGINAIS' ||
                          filtros.situacao === 'ARQUIVADOS' ||
                          filtros.situacao === 'CONSOLIDADOS'
                      "
                      color="primary"
                      v-bind="props"
                      @input="toggleAllCheckboxes"
                      v-on="on"
                    />
                  </template>
                  <template
                    v-slot:[`item.data-table-select`]="{
                      isSelected,
                      select,
                      item,
                    }"
                  >
                    <v-tooltip
                      :disabled="
                        item.consolidado ||
                          item.excluido === true ||
                          filtros.situacao === 'ORIGINAIS'
                      "
                      right
                    >
                      <template v-slot:activator="{ on }">
                        <div
                          v-ripple
                          v-on="on"
                        >
                          <v-simple-checkbox
                            :disabled="
                              item.consolidado ||
                                item.excluido === true ||
                                filtros.situacao === 'ORIGINAIS'
                            "
                            :value="isSelected"
                            color="primary"
                            @input="select($event)"
                          />
                        </div>
                      </template>
                      <span>O comportamento não pode ser consolidado antes de ser
                        associado a uma competência</span>
                    </v-tooltip>
                  </template>
                  <template v-slot:[`item.comportamento`]="{ item }">
                    <v-row no-gutters>
                      <v-tooltip
                        :disabled="
                          item.consolidado || !prazoAtual || item.excluido
                        "
                        top
                      >
                        <template v-slot:activator="{ on }">
                          <div
                            style="display: inline-block"
                            v-on="on"
                          >
                            <v-edit-dialog
                              v-if="
                                !item.consolidado &&
                                  prazoAtual &&
                                  !item.excluido
                              "
                              save-text="Salvar"
                              cancel-text="Cancelar"
                              large
                              lazy
                              @open="
                                item.descricaoAtualizada === null ||
                                  item.descricaoAtualizada === item.descricao
                                  ? (descricaoNova = item.descricao)
                                  : (descricaoNova = item.descricaoAtualizada)
                              "
                              @save="editarDescricao(item)"
                            >
                              {{
                                filtros.situacao === "ORIGINAIS" ||
                                  (filtros.situacao !== "ORIGINAIS" &&
                                    item.descricaoAtualizada === null)
                                  ? item.descricao
                                  : item.descricaoAtualizada
                              }}
                              <v-icon
                                color="secondary"
                                small
                                v-on="on"
                              >
                                edit
                              </v-icon>
                              <template v-slot:input>
                                <v-textarea
                                  v-model.trim="descricaoNova"
                                  label="Editar comportamento"
                                  rows="3"
                                />
                              </template>
                            </v-edit-dialog>
                            <span v-else>
                              {{
                                filtros.situacao === "ORIGINAIS" ||
                                  (filtros.situacao !== "ORIGINAIS" &&
                                    item.descricaoAtualizada === null)
                                  ? item.descricao
                                  : item.descricaoAtualizada
                              }}
                            </span>
                          </div>
                        </template>
                        <span>Clique para editar o título do comportamento</span>
                      </v-tooltip>
                      <v-tooltip
                        max-width="500px"
                        top
                      >
                        <template v-slot:activator="{ on }">
                          <v-chip
                            v-show="
                              item.descricao !== item.descricaoAtualizada &&
                                item.descricaoAtualizada !== null
                            "
                            class="mb-2 ml-2"
                            color="secondary"
                            outlined
                            small
                            v-on="on"
                          >
                            Editado
                          </v-chip>
                        </template>
                        <span><strong
                                style="color: #9fdfeb"
                              >Comportamento Original:</strong>
                          {{ item.descricao }}</span>
                      </v-tooltip>
                      <v-chip
                        v-show="item.consolidado"
                        class="mb-2 ml-2"
                        color="success"
                        outlined
                        small
                      >
                        Consolidado
                      </v-chip>
                      <v-chip
                        v-show="item.excluido"
                        class="mb-2 ml-2"
                        color="error"
                        outlined
                        small
                      >
                        Arquivado
                      </v-chip>
                    </v-row>
                  </template>
                  <template v-slot:[`item.competencia`]="{ item }">
                    <span v-show="!prazoAtual">{{
                      item.competencia ? item.competencia.nome : "-"
                    }}</span>
                    <v-select
                      v-show="prazoAtual"
                      v-model="item.competencia"
                      :disabled="item.consolidado || item.excluido"
                      :items="competenciasAssociacao"
                      item-text="nome"
                      item-value="id"
                      label="Selecione uma competência"
                      return-object
                      @input="associarCompetencia(item)"
                    >
                      <template v-slot:item="data">
                        <v-tooltip
                          max-width="500px"
                          top
                        >
                          <template v-slot:activator="{ on }">
                            <span v-on="on">{{ data.item.nome }}</span>
                          </template>
                          <span
                            v-if="data.item.nome === 'Nenhuma...'"
                          >Nenhuma competência comportamental</span>
                          <span v-else>{{ data.item.descricao }}</span>
                        </v-tooltip>
                      </template>
                    </v-select>
                  </template>
                  <template v-slot:[`item.importancia`]="{ item }">
                    <span
                      v-show="item.consolidado || item.excluido || !prazoAtual"
                    >{{ item.importancia }}</span>
                    <v-text-field
                      v-show="!item.consolidado && !item.excluido && prazoAtual"
                      v-model="item.importancia"
                      :min="1"
                      type="number"
                      @change="atualizarImportancia(item)"
                    />
                  </template>
                  <template
                    v-if="prazoAtual"
                    v-slot:[`item.acoes`]="{ item }"
                  >
                    <v-tooltip left>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-show="
                            item.descricaoAtualizada !== null &&
                              item.descricao !== item.descricaoAtualizada &&
                              !item.consolidado
                          "
                          color="secondary"
                          icon
                          small
                          @click="restaurarTexto(item)"
                          v-on="on"
                        >
                          <v-icon>settings_backup_restore</v-icon>
                        </v-btn>
                      </template>
                      <span>Clique para restaurar o texto original do
                        comportamento</span>
                    </v-tooltip>
                    <v-tooltip left>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-show="!item.excluido && !item.consolidado"
                          color="error"
                          icon
                          small
                          @click="
                            (comportamento = item),
                            (dialogs.removeComportamento = true)
                          "
                          v-on="on"
                        >
                          <v-icon>archive</v-icon>
                        </v-btn>
                      </template>
                      <span>Clique no botão para arquivar o comportamento</span>
                    </v-tooltip>
                    <v-tooltip left>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-show="item.excluido && !item.consolidado"
                          color="error"
                          icon
                          small
                          @click="restaurar(item)"
                          v-on="on"
                        >
                          <v-icon>settings_backup_restore</v-icon>
                        </v-btn>
                      </template>
                      <span>Clique no botão para restaurar o comportamento</span>
                    </v-tooltip>
                    <v-tooltip left>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-show="!item.excluido && item.consolidado"
                          color="success"
                          icon
                          small
                          @click="desconsolidar(item)"
                          v-on="on"
                        >
                          <v-icon>settings_backup_restore</v-icon>
                        </v-btn>
                      </template>
                      <span>Clique no botão para cancelar a consolidação do
                        comportamento</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <!-- Botão XLS -->
        <v-row
          no-gutters
          class="justify-end mb-1"
        >
          <v-tooltip
            top
            max-width="400"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                color="success"
                class="mr-2"
                @click="generateWorksheet()"
                v-on="on"
              >
                <v-icon>get_app</v-icon>
                BAIXAR XLS
              </v-btn>
            </template>
            <span>Clique para baixar os dados em formato XLS.</span>
          </v-tooltip>
        </v-row>
      </template>
      <template v-slot:actions>
        <v-row no-gutters>
          <div
            v-show="prazoAtual"
            class="text-lg-right"
          >
            <v-tooltip
              v-if="prazoAtual"
              bottom
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  :disabled="!enableConsolidacao"
                  color="primary"
                  @click="consolidar"
                  v-on="on"
                >
                  Consolidar
                  <v-icon class="ml-2">
                    folder_copy
                  </v-icon>
                </v-btn>
              </template>
              <span>Clique no botão para consolidar o(s) comportamento(s)
                selecionado(s)</span>
            </v-tooltip>
          </div>
        </v-row>
      </template>
    </app-mapeamento>

    <v-dialog
      v-model="dialogs.removeComportamento"
      max-width="370"
      persistent
    >
      <v-card>
        <v-card-title class="headline" />
        <v-card-text>
          Você realmente deseja arquivar esse comportamento?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="error"
            text
            @click="arquivar()"
          >
            Arquivar
          </v-btn>
          <v-btn
            color="grey"
            text
            @click="toogleRemoveComportamento"
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import AppSort from '@/components/core/AppSort';
import AppSearch from '@/components/core/AppSearch';
import AppMapeamento from '@/components/core/AppMapeamento';
import Data from '@/modules/data';
import { pesquisar } from '@/modules/texto';
import { generateXLS } from '@/modules/relatorioPlanilha';

const comportamentosRepository = RepositoryFactory.get('comportamento');

export default {
  components: { AppSort, AppSearch, AppMapeamento },

  data() {
    return {
      filtros: {
        unidades: [],
        situacao: 'TODOS',
        competencia: { id: null, nome: 'Todas' },
      },
      headers: [
        {
          text: 'COMPORTAMENTO',
          value: 'comportamento',
          align: 'start',
          sortable: false,
        },
        {
          text: '',
          value: 'descricaoAtualizada',
          align: ' d-none',
          sortable: false,
        },
        {
          text: 'UNIDADE',
          value: 'unidade.sigla',
          align: 'start',
          sortable: false,
        },
        { text: 'COMPETÊNCIA', value: 'competencia', sortable: false },
        {
          text: 'IMPORTÂNCIA',
          value: 'importancia',
          width: '5%',
          sortable: false,
          align: 'center',
        },
        {
          text: '',
          value: 'acoes',
          sortable: false,
          width: '8%',
          align: 'right',
        },
      ],
      opcoes: {
        pesquisa: '',
        decrescente: false,
        ordenarPor: 'descricaoAtualizada',
        selecionado: { id: 'descricaoAtualizada', descricao: 'Comportamento' },
        lista: [
          { id: 'competencia.nome', descricao: 'Competência' },
          { id: 'descricaoAtualizada', descricao: 'Comportamento' },
          { id: 'importancia', descricao: 'Importância' },
          { id: 'unidade.sigla', descricao: 'Unidade' },
        ],
      },
      pesquisaUnidades: null,
      descricaoNova: '',
      selectedComportamentos: [],
      competencia: { id: '', nome: '' },
      comportamento: null,
      situacoes: [
        { id: 'TODOS', descricao: 'Todos' },
        { id: 'ARQUIVADOS', descricao: 'Arquivados' },
        { id: 'ASSOCIADOS', descricao: 'Associados' },
        { id: 'CONSOLIDADOS', descricao: 'Consolidados' },
        { id: 'EDITADOS', descricao: 'Editados' },
        { id: 'NAO_ASSOCIADOS', descricao: 'Não Associados' },
        { id: 'NAO_CONSOLIDADOS', descricao: 'Não Consolidados' },
        { id: 'ORIGINAIS', descricao: 'Originais' },
      ],
      dialogs: {
        removeComportamento: false,
      },
    };
  },

  computed: {
    ...mapState({
      mapeamentos: (state) => state.mapeamento.mapeamentos,
      competencias: (state) => state.competencia.competenciasComportamentais,
      isTutorialExibido: (state) => state.tutorial.dados.normalizacaoComportamental,
      unidade: (state) => state.auth.unidade,
      mapeamento: (state) => state.mapeamento.mapeamentoComissao,
    }),
    unidades() {
      const unidades = [this.mapeamento.unidade, ...this.mapeamento.unidades];
      return unidades.sort((a, b) => {
        if (a.sigla < b.sigla) {
          return -1;
        }
        if (a.sigla > b.sigla) {
          return 1;
        }
        return 0;
      });
    },
    comportamentosArmazenados: {
      get() {
        return this.$store.state.comportamento.comportamentosComissao;
      },
      set(comportamentos) {
        const payload = { tipo: 'COMISSAO', comportamentos };
        this.$store.dispatch('comportamento/setComportamentos', payload);
      },
    },
    comportamentos() {
      let comportamentos;
      if (this.mapeamento.mapeamentoImportado) {
        comportamentos = [...this.comportamentosArmazenados];
      } else {
        comportamentos = this.comportamentosArmazenados
          .filter((c) => this.filtros.unidades.some((u) => u.idVersao === c.unidade.id));
      }
      return comportamentos.filter(
        (c) => (this.filtros.situacao === 'NAO_ASSOCIADOS'
            || this.filtros.competencia.id === null
            || (c.competencia !== null && this.filtros.competencia.id === c.competencia.id))
          && (this.filtros.situacao === 'TODOS'
            || (this.filtros.situacao === 'ORIGINAIS'
              && !(c.descricaoAtualizada !== null && c.descricao !== c.descricaoAtualizada))
            || (this.filtros.situacao === 'EDITADOS'
              && c.descricaoAtualizada !== null
              && c.descricao !== c.descricaoAtualizada)
            || (this.filtros.situacao === 'ASSOCIADOS' && c.competencia !== null)
            || (this.filtros.situacao === 'NAO_ASSOCIADOS' && c.competencia === null)
            || (this.filtros.situacao === 'CONSOLIDADOS' && c.consolidado)
            || (this.filtros.situacao === 'NAO_CONSOLIDADOS' && !c.consolidado)
            || (this.filtros.situacao === 'ARQUIVADOS' && c.excluido)),
      );
    },
    competenciasAssociacao() {
      const competencias = [...this.competencias];
      competencias.sort((a, b) => {
        if (a.nome < b.nome) {
          return -1;
        }
        if (a.nome > b.nome) {
          return 1;
        }
        return 0;
      });
      competencias.unshift({ id: null, nome: 'Nenhuma...' });
      competencias.push(
        competencias.splice(
          competencias.findIndex((c) => c.nome === 'Outros'),
          1,
        )[0],
      );
      return competencias;
    },
    competenciasFiltro() {
      const competencias = [...this.competencias];
      competencias.sort((a, b) => {
        if (a.nome < b.nome) {
          return -1;
        }
        if (a.nome > b.nome) {
          return 1;
        }
        return 0;
      });
      competencias.unshift({ id: null, nome: 'Todas' });
      competencias.push(
        competencias.splice(
          competencias.findIndex((c) => c.nome === 'Outros'),
          1,
        )[0],
      );
      return competencias;
    },
    selectAllItens() {
      return this.filtros.unidades.length === this.unidades.length;
    },
    selectSomeItens() {
      return this.filtros.unidades.length > 0 && !this.selectAllItens;
    },
    icon() {
      if (this.selectAllItens) {
        return 'check_box';
      }
      if (this.selectSomeItens) {
        return 'indeterminate_check_box';
      }
      return 'check_box_outline_blank';
    },
    enableConsolidacao() {
      let enable = this.selectedComportamentos.length;
      this.selectedComportamentos.forEach((item) => {
        if (item.competencia === null || item.competencia.id === null) {
          enable = false;
        }
      });
      return enable;
    },
    prazoAtual() {
      return !this.prazoEsgotado && !this.prazoFuturo;
    },
    prazoEsgotado() {
      return Data.compare('isAfter', { b: this.mapeamento.fimPerComportComissao });
    },
    prazoFuturo() {
      return Data.compare('isBefore', { b: this.mapeamento.inicioPerComportComissao });
    },
  },

  watch: {
    mapeamento() {
      this.comportamentosArmazenados.splice(0);
      this.filtros.unidades = [];
      this.loadComportamentos();
    },
    'filtros.unidades': function (value) {
      if (value.length > 0) {
        this.loadComportamentos();
      }
    },
  },

  created() {
    if (this.mapeamento.mapeamentoImportado) {
      this.loadComportamentos();
    }
  },

  methods: {
    loadComportamentos() {
      if (this.comportamentosArmazenados.length === 0 && (this.prazoAtual || this.prazoEsgotado)) {
        const payload = { mapeamento: this.mapeamento.id, comissao: true };
        this.$store.dispatch('comportamento/load', payload).then(() => {
          if (!this.isTutorialExibido && this.prazoAtual) {
            this.$store.dispatch('app/showTutorial', { nome: 'NormalizacaoComportamental' });
          }
        });
      }
    },
    getUnidadeSiglaAndNome(item) {
      return `${item.sigla} - ${item.nome}`;
    },
    editarDescricao(item) {
      if (item.descricaoAtualizada !== this.descricaoNova) {
        const comportamento = { ...item };
        comportamento.descricaoAtualizada = this.descricaoNova;
        this.editar(comportamento).then((res) => {
          this.$store.dispatch('app/success', { response: res, message: 'Descrição atualizada com sucesso!' });
        });
      }
    },
    editar(comportamento) {
      return new Promise((resolve) => {
        comportamentosRepository.update(true, comportamento).then((res) => {
          comportamento = res.data;
          if (comportamento.id) {
            const index = this.comportamentosArmazenados.findIndex((c) => c.id === comportamento.id);
            if (index !== -1) {
              this.comportamentosArmazenados.splice(index, 1, comportamento);
            }
          }
          resolve(res);
        });
      });
    },
    atualizarImportancia(item) {
      this.editar(item).then((res) => {
        this.$store.dispatch('app/success', { response: res, message: 'Importância atualizada com sucesso!' });
      });
    },
    associarCompetencia(item) {
      this.editar(item).then((res) => {
        this.$store.dispatch('app/success', { response: res, message: 'Competência associada com sucesso!' });
      });
    },
    associar() {
      if (this.selectedComportamentos.length > 0) {
        const comportamentos = [...this.selectedComportamentos];
        comportamentos.forEach((c) => (c.competencia = this.competencia));
        comportamentosRepository.vincular(comportamentos).then((res) => {
          const comportamentosVinculados = res.data;
          const comportamentosNaoAlterados = this.comportamentosArmazenados.filter(
            (c) => !comportamentosVinculados.some((c2) => c2.id === c.id),
          );
          this.comportamentosArmazenados = [...comportamentosVinculados, ...comportamentosNaoAlterados];
          this.toggleAllCheckboxes();
          this.$store.dispatch('app/success', { response: res, message: 'Competência(s) associada(s) com sucesso!' });
          this.competencia = { id: '', nome: '' };
        });
      }
    },
    consolidar() {
      if (this.selectedComportamentos.length > 0) {
        comportamentosRepository.consolidar(this.selectedComportamentos).then((res) => {
          const comportamentos = res.data;
          const comportamentosNaoAlterados = this.comportamentosArmazenados.filter(
            (c) => !comportamentos.some((c2) => c2.id === c.id),
          );
          this.comportamentosArmazenados = [...comportamentos, ...comportamentosNaoAlterados];
          this.toggleAllCheckboxes();
          this.$store.dispatch('app/success', {
            response: res,
            message: 'Comportamento(s) consolidado(s) com sucesso!',
          });
        });
      }
    },
    arquivar() {
      const comp = { ...this.comportamento };
      comp.excluido = true;
      this.editar(comp).then((res) => {
        this.$store.dispatch('app/success', { response: res, message: 'Comportamento arquivado com sucesso!' });
      });
      this.toogleRemoveComportamento();
    },
    restaurar(item) {
      const comp = { ...item };
      comp.excluido = false;
      this.editar(comp).then((res) => {
        this.$store.dispatch('app/success', { response: res, message: 'Comportamento resturado com sucesso!' });
      });
    },
    restaurarTexto(item) {
      const comp = { ...item };
      comp.editado = false;
      comp.descricaoAtualizada = null;
      this.editar(comp).then((res) => {
        this.$store.dispatch('app/success', {
          response: res,
          message: 'O Texto original do comportamento foi resturado com sucesso!',
        });
      });
    },
    desconsolidar(item) {
      const comp = { ...item };
      comp.consolidado = false;
      this.editar(comp).then((res) => {
        this.$store.dispatch('app/success', { response: res, message: 'Consolidação desfeita com sucesso!' });
      });
    },
    removeUnidade(item) {
      const index = this.filtros.unidades.findIndex((u) => u.id === item.id);
      if (index !== -1) {
        this.filtros.unidades.splice(index, 1);
      }
    },
    toggleItens() {
      this.$nextTick(() => {
        if (this.selectAllItens) {
          this.filtros.unidades = [];
        } else {
          this.filtros.unidades = [...this.unidades];
        }
      });
    },
    toggleAllCheckboxes() {
      if (this.selectedComportamentos.length) {
        this.selectedComportamentos = [];
      } else {
        this.selectedComportamentos = this.comportamentos.filter((c) => !c.consolidado && !c.excluido);
      }
    },
    toogleRemoveComportamento() {
      this.dialogs.removeComportamento = !this.dialogs.removeComportamento;
      this.comportamento = null;
    },
    customFilter(value, search, item) {
      return (
        pesquisar(item.descricao, search)
        || pesquisar(item.descricaoAtualizada, search)
        || (item.unidade && pesquisar(item.unidade.sigla, search))
        || (item.competencia && pesquisar(item.competencia.nome, search))
      );
    },
    generateWorksheet() {
      const documento = {
        titulo: `comportamentos-${this.filtros.situacao.toLowerCase()}`,
        planilhas: [
          {
            titulo: `Comportamentos ${this.filtros.situacao.toLowerCase()}`,
            colunas: [
              { header: 'COMPORTAMENTO', key: 'comportamento', width: 50 },
              { header: 'SITUAÇÃO', key: 'situacao', width: 40 },
              { header: 'UNIDADE', key: 'unidade', width: 15 },
              { header: 'COMPETÊNCIA', key: 'competencia', width: 40 },
              { header: 'IMPORTÂNCIA', key: 'importancia', width: 15 },
            ],
            dados: this.comportamentos.map((c) => {
              let situacao = '';

              if (c.excluido) {
                situacao = '[Arquivado] ';
              }

              if (c.consolidado) {
                situacao += 'Consolidado';
              } else if (c.descricaoAtualizada !== null && c.descricao !== c.descricaoAtualizada) {
                situacao += 'Editado';
              } else {
                situacao += 'Original';
              }

              return {
                comportamento: c.descricaoAtualizada === null ? c.descricao : c.descricaoAtualizada,
                situacao,
                unidade: c.unidade === null ? '--' : c.unidade.sigla,
                competencia: c.competencia ? c.competencia.nome : '',
                importancia: c.importancia,
              };
            }).sort((a, b) => a.comportamento.localeCompare(b.comportamento)),
          },
        ],
      };

      generateXLS(documento);
    },
  },
};
</script>
